import script from "./GrIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./GrIcon.vue?vue&type=script&setup=true&lang=js"

import "./GrIcon.vue?vue&type=style&index=0&id=d2ccb2ac&lang=scss"

const __exports__ = script;

export default __exports__